import { useEffect, useRef } from 'react';
import { Conversations, WebSocketMessageType } from '../../model';
import { WS_API_CONVERSATION_URL } from '../../../api/ConversationApi';
import { getAuthToken } from '../../security/AuthContext';

export const useConversationSocket = (
  uuid: string | undefined,
  setConversation: React.Dispatch<React.SetStateAction<Conversations | null>>,
  setIsNewMessage: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const socketRef = useRef<WebSocket | null>(null);

  useEffect(() => {
    if (!uuid) return;

    const token = getAuthToken();
    const ws = new WebSocket(
      `${WS_API_CONVERSATION_URL}/${uuid}?token=${token}`
    );

    ws.onopen = () => {
      setIsNewMessage(false);
      socketRef.current = ws;
    };

    ws.onmessage = event => {
      const messageData = JSON.parse(event.data);

      if (messageData.type === WebSocketMessageType.MESSAGE) {
        const message = messageData.message;
        setConversation(prev =>
          prev
            ? {
                ...prev,
                chatMessages: [...(prev.chatMessages || []), message],
              }
            : prev
        );
        setIsNewMessage(true);
        setTimeout(() => setIsNewMessage(false), 1000);
      } else if (messageData.type === WebSocketMessageType.CONVERSATION) {
        const summary = messageData.message?.summary;
        const metadata = messageData.message?.metadata;
        setConversation(prev =>
          prev
            ? {
                ...prev,
                summary,
                metadata,
              }
            : prev
        );
        setIsNewMessage(true);
        setTimeout(() => setIsNewMessage(false), 1000);
      }
    };

    ws.onclose = () => {
      socketRef.current = null;
    };

    return () => {
      if (
        ws.readyState === WebSocket.OPEN ||
        ws.readyState === WebSocket.CONNECTING
      ) {
        ws.close();
      }
    };
  }, [uuid, setConversation, setIsNewMessage]);

  return socketRef;
};
